// 菜单，顶栏

export default [{
  path: '/',
  title: '系统',
  icon: 'md-options',
  hideSider: true,
  name: 'home',
  auth: ['hidden']
}, {
  path: '/system',
  title: '系统管理',
  icon: 'md-options',
  hideSider: false,
  name: 'system',
  auth: ['admin']
}];